<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 text-center">
				<h4>ទឹកប្រាក់ត្រូវទូទាត់ទៅកាន់ក្រុមហ៊ុន</h4>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50 text-center">
				<h4>{{config.moneylify(getPaymentUSD, 'usd')}}</h4>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50 text-center">
				<h4>{{config.moneylify(getPaymentKHR, 'khr')}}</h4>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-70 md-size-50">
				<md-button class="md-primary" @click="goScan()" style="width: 100%">ស្កេនបើកកញ្ចប់ឥវ៉ាន់</md-button>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-30 md-size-50">
				<md-button class="md-primary" @click="getPackage()" style="width: 100%">ទាញធ្វើអោយថ្មី</md-button>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 text-center"
				v-if="loaded && packageList.length == 0">
				<h4>អ្នកមិនទាន់មានកញ្ចប់ឥវ៉ាន់ទេ</h4>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33" v-for="pkg in packageList">
				<stats-card data-background-color="orange">
					<!-- <template slot="header">
						<md-icon>card_giftcard</md-icon>
					</template> -->
					<template slot="content">
						<p class="category">
						<table style="width: 100%">
							<tr>
								<td>លេខកូដ</td>
								<td>:</td>
								<td>
									<div style="width: 100%;display: flex; justify-content: space-between;">
										<div>{{pkg.tracking}}</div>
										<div>
											<span style="text-align: right; margin-right: 8px; cursor: pointer;" class="neutral" @click="exchange(pkg.hash_id)" v-if="pkg.status != 'dlv' && pkg.price_currency == 'usd'">$→៛</span>
											<span style="text-align: right;margin-left:8px;cursor: pointer;" class="gray" @click="note(pkg.hash_id)">ចំណាំ</span>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<td>ទីតាំង</td>
								<td>:</td>
								<td>{{pkg.location}} ({{pkg.package_type}})</td>
							</tr>
							<tr>
								<td>តម្លៃឥវ៉ាន់</td>
								<td>:</td>
								<td>{{config.moneylify(pkg.price, pkg.price_currency)}}
									(<span v-if="pkg.price == 0">ទូទាត់រួច</span>
									<span v-else>មិនទាន់ទូទាត់</span>)
								</td>
							</tr>
							<tr>
								<td>ថ្លៃដឹកជញ្ជូន</td>
								<td>:</td>
								<td v-if="pkg.fee_responsible == 'snd'">
									{{config.moneylify(0, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
								<td v-else>
									{{config.moneylify(pkg.fee, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
							</tr>
							<tr>
								<td>ឈ្មោះអ្នកផ្ញើរ</td>
								<td>:</td>
								<td>{{pkg.client_name}}</td>
							</tr>
							<tr>
								<td>ទូរស័ព្ទអ្នកផ្ញើរ</td>
								<td>:</td>
								<td>{{pkg.sender_phone}}</td>
							</tr>
							<tr>
								<td>អ្នកទទួល</td>
								<td>:</td>
								<td>{{pkg.receiver_phone}}</td>
							</tr>
							<tr v-if="pkg.note != ''" class="note-row">
								<td>ចំណាំ</td>
								<td>:</td>
								<td>{{pkg.note}}</td>
							</tr>
							<tr>
								<td>កាលបរិច្ឆេត</td>
								<td>:</td>
								<td>{{config.datelify(pkg.created_date)}}</td>
							</tr>
						</table>

						</p>
						<p style="text-align: right;">
							<span style="text-align: right; margin-right: 8px; cursor: pointer;" class="neutral" @click="showQR(pkg.hash_id)">QR</span>
							
							<span style="text-align: right;" class="late" v-if="pkg.status == 'wdv'">រង់ចាំអ្នកដឹកជញ្ជូន</span>
							<span style="text-align: right;" class="neutral" v-if="pkg.status == 'dvr'">កំពុងដឹកជញ្ជូន</span>
							<span style="text-align: right;" class="active" v-if="pkg.status == 'dlv'">បានដល់អតិថិជន</span>
							
							<span style="text-align: right;margin-left:8px;cursor: pointer;" class="active" v-if="pkg.status == 'dvr'" @click="deliver(pkg.hash_id)">បញ្ជាក់ថាបានដល់អ្នកទទួល</span>
							<span style="text-align: right;margin-left:8px;cursor: pointer;" class="active" v-if="pkg.status == 'wdv'" @click="pick(pkg.hash_id)">បញ្ជាក់ថាបានបើកកញ្ចប់ឥវ៉ាន់</span>
							<!-- <md-button class="md-primary" @click="">បញ្ជាក់ថាបានដឹករួចរាល់</md-button> -->
						</p>
					</template>
				</stats-card>
			</div>
		</div>
		<div class="box" v-if="QRactive" style="background-color: rgba(0,0,0,0.4); position: fixed; width: 100%; height: 100%; top: 0; left: 0; z-index: 99; display: flex; justify-content: center; align-items: center;" @click="clearQR()">
			<div style="background-color: #FFF; border-radius: 6px; padding: 15px; width: 80%; max-width: 300px;">
				<qr-code :text="'admin-'+selectedQR" :size="300" style="width: 100%"></qr-code>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="deliverActive" md-title="បញ្ជាក់ថាបានដល់អ្នកទទួល ?" md-confirm-text="យល់ព្រម"
			md-cancel-text="បិទ" @md-cancel="onCancel" @md-confirm="deliver" />
		<md-dialog-confirm :md-active.sync="pickActive" md-title="បញ្ជាក់ថាបានបើកកញ្ចប់ឥវ៉ាន់នេះរួចរាល់ ?" md-confirm-text="យល់ព្រម"
			md-cancel-text="បិទ" @md-cancel="onCancel" @md-confirm="pick" />

		<md-dialog-confirm :md-active.sync="exchangeActive" md-title="តើអ្នកពិតជាចង់ផ្លាស់ប្តូររូបិយប័ណ្ណកញ្ចប់នេះមែនទេ ?" md-confirm-text="យល់ព្រម"
			md-cancel-text="បិទ" @md-cancel="onCancel" @md-confirm="exchange" />
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			StatsCard,
			'qr-code': VueQRCodeComponent,
		},
		data() {
			return {
				loaded: false,
				packageList: [],
				deliverHash: "",
				deliverActive: false,
				pickHash: "",
				pickActive: false,
				exchangeHash: "",
				exchangeActive: false,
				selectedQR: "",
				QRactive: false
			}
		},

		created() {
			this.getPackage();
		},
		computed: {
			getPaymentUSD() {
				let total = 0;
				for (let i = 0; i < this.packageList.length; i++) {
					if (this.packageList[i].status == 'dlv') {
						if (this.packageList[i].price_currency == 'usd') {
							total = total + this.packageList[i].price
						}

						if (this.packageList[i].fee_currency == 'usd' && this.packageList[i].fee_responsible == 'rcv') {
							total = total + this.packageList[i].fee
						}

					}
				}
				return total;
			},
			getPaymentKHR() {
				let total = 0;
				for (let i = 0; i < this.packageList.length; i++) {
					if (this.packageList[i].status == 'dlv') {
						if (this.packageList[i].price_currency == 'khr') {
							total = total + this.packageList[i].price
						}

						if (this.packageList[i].fee_currency == 'khr' && this.packageList[i].fee_responsible == 'rcv') {
							total = total + this.packageList[i].fee
						}

					}
				}
				return total;
			}
		},
		methods: {
			exchange(hash_id) {
				if (this.exchangeHash == "" && String(hash_id).length > 0) {
					this.exchangeHash = hash_id
					this.exchangeActive = true;
				} else {
					this.$http.post(this.config.api + "/admin/package/exchange_to_khr", {
						package_hash_id: this.exchangeHash
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "ផ្លាស់ប្តូររួចរាល់។",
								icon: 'done',
								type: 'success'
							})
							this.getPackage();
						}
					})
				}
			},
			clearQR() {
				this.selectedQR = "";
				this.QRactive = false;
			},
			showQR(hash) {
				this.QRactive = true;
				this.selectedQR = hash;
			},
			getPackage() {
				this.loaded = false;
				this.$http.get(this.config.api + "/admin/driver/get_package").then(data => {
					this.packageList = data.body.data
					this.loaded = true
				});
			},

			goScan() {
				this.$router.push("/scan");
			},
			note(hash_id) {
				this.$router.push("/note/" + hash_id)
			},
			deliver(hash_id = "") {
				if (this.deliverHash == "" && String(hash_id).length > 0) {
					this.deliverHash = hash_id
					this.deliverActive = true;
				} else {
					this.$http.post(this.config.api + "/admin/driver/deliver", {
						hash_id: this.deliverHash
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "បានបញ្ចប់",
								icon: 'done',
								type: 'success'
							})
							this.getPackage();
						}
					})
				}

			},
			pick(hash_id = "") {
				if (this.pickHash == "" && String(hash_id).length > 0) {
					this.pickHash = hash_id
					this.pickActive = true;
				} else {
					this.$http.post(this.config.api + "/admin/driver/pick", {
						hash_id: this.pickHash
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់កំពុងដឹកជញ្ជូន",
								icon: 'done',
								type: 'success'
							})
							this.getPackage();
						}
					})
				}

			},
			onCancel() {
				this.deliverHash = "",
				this.deliverActive = false
				this.pickHash = ""
				this.pickActive = false
				this.exchangeHash = ""
				this.exchangeActive = false
			}
		}
	}
</script>
<style>
	.note-row {
		color: red;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard.vue